/**
 * Header JS - Mobile menu toggle, desktop mega menu, accordion submenus
 * Matches React Layout.tsx header interactions
 */
(function () {
  'use strict';

  /* ---- Mobile Menu Toggle ---- */
  const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuClose = document.querySelector('[data-mobile-menu-close]');
  const menuOverlay = document.querySelector('[data-mobile-menu-overlay]');

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    if (menuOverlay) menuOverlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    if (menuOverlay) menuOverlay.style.display = '';
    document.body.style.overflow = '';
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
  }

  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

  /* Close mobile menu on Escape key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) {
      closeMenu();
    }
  });

  /* ---- Mobile Accordion Submenus ---- */
  document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      const parent = trigger.closest('.mobile-menu__item');
      if (!parent) return;
      const content = parent.querySelector('[data-mobile-submenu]');
      if (!content) return;

      const isOpen = parent.classList.contains('is-open');

      // Close all siblings
      parent.parentElement.querySelectorAll('.mobile-menu__item.is-open').forEach(function (el) {
        if (el !== parent) {
          el.classList.remove('is-open');
          var c = el.querySelector('[data-mobile-submenu]');
          if (c) c.style.maxHeight = null;
          // Reset chevron icons on sibling
          var sibChevronRight = el.querySelector('.chevron-right');
          var sibChevronDown = el.querySelector('.chevron-down');
          if (sibChevronRight) sibChevronRight.style.display = '';
          if (sibChevronDown) sibChevronDown.style.display = 'none';
        }
      });

      // Toggle chevron icons
      var chevronRight = trigger.querySelector('.chevron-right');
      var chevronDown = trigger.querySelector('.chevron-down');

      if (isOpen) {
        parent.classList.remove('is-open');
        content.style.maxHeight = null;
        if (chevronRight) chevronRight.style.display = '';
        if (chevronDown) chevronDown.style.display = 'none';
      } else {
        parent.classList.add('is-open');
        content.style.maxHeight = content.scrollHeight + 'px';
        if (chevronRight) chevronRight.style.display = 'none';
        if (chevronDown) chevronDown.style.display = '';
      }
    });
  });

  /* ---- Sticky Header ---- */
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', function () {
      const st = window.scrollY;
      if (st > 100) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
      lastScroll = st;
    }, { passive: true });
  }

  /* ---- Desktop Search Toggle ---- */
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchBar = document.querySelector('[data-search-bar]');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      searchBar.classList.toggle('is-visible');
      const input = searchBar.querySelector('input');
      if (input && searchBar.classList.contains('is-visible')) input.focus();
    });
  }
})();
